(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-password"]) return;
  try {
    
document.querySelectorAll('.mk-pw form').forEach(function(form) {
  form.addEventListener('submit', function() {
    var btn = form.querySelector('[type="submit"]');
    if (btn && !btn.disabled) {
      btn.disabled = true;
      btn.setAttribute('aria-busy', 'true');
    }
  });
});

  } catch(e) { console.error(e); }
})();
})();
